"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getLanguageFromLanguageCode = require("./getLanguageFromLanguageCode");
Object.keys(_getLanguageFromLanguageCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getLanguageFromLanguageCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getLanguageFromLanguageCode[key];
    }
  });
});
